<template>
  <v-container fluid fill-height class="login-container">
    <img class="login-bg" src="@/assets/login__background.png" alt />
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="login-form">
          <div class="login-logo">
            <img src="@/assets/white_logo.png" alt="logo" class="center-block" />
          </div>
          <v-card-text>
            <v-form v-model="valid">
              <v-alert v-if="error"
                dense
                text
                type="error">{{msj}}</v-alert>
              <v-alert class="mt-4 mb-4"
                v-if="emailSent"
                dense
                text
                type="success"
              >
                {{language.check_your_email}}
              </v-alert>
              <v-text-field
                required
                :rules="required"
                class="user-prefix"
                v-model="text1"
                :label="language.user"
                type="email"
                solo
              ></v-text-field>
            </v-form>
            <v-btn
              :disabled="!valid"
              block
              color="white"
              @click="validateLogin"
              rounded
              class="login-separador-btn"
            >{{language.reset_my_password}}</v-btn>
            <v-btn block color="secondary" to="/" rounded>{{language.login}}</v-btn>



          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar :timeout="2000" v-model="snackbarLogin">
      {{ language.invalid_username }}
      <v-btn text @click.native="snackbarLogin = false">{{language.close}}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
// import Language from "../utils/language";
export default {
  created(){
    console.log(this.language);
  },
  mounted() {
    if (this.login === true) {
      this.$router.push("home");
    }
  },
  data: function () {
    return {
      valid: false,
      text1: "",
      text2: "",
      error: false,
      emailSent:false,
      msj: "",
      required: [(v) => !!v || this.language.the_field_is_required],
      emailRules: [
        (v) => !!v || this.language.the_field_is_required,
        (v) =>
          /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(
            v
          ) || this.language.the_email_must_be_valid,
      ],
      snackbarLogin: false,


    };
  },
  computed: {
    login: function () {
      return this.$store.getters.login;
    },
    profile: function () {
      return this.$store.getters.profile;
    },
    language: function () {
      return this.$store.getters.language;
    },

  },
  methods: {
    validateLogin: function () {
      // const _this = this;

      // this.$store.dispatch('login', true)
      // this.$router.push('packages')

      var formData = new FormData();
      formData.append("text1", this.text1);
      formData.append("device", window.MobileApi.device);

      this.$http.post(Server.resetPassword, formData).then(
        (response) => {
          console.log(response.body.resultado);
          if (response.body.resultado != 0) {
            this.emailSent = true;
            this.error = false;
          } else {
            this.error = true;
            this.msj = this.language.invalid_username;
            this.emailSent = false;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );

      // Helpers.getJson(Server.login, 'POST', formData, function (json) {
      //   console.log(json.resultado)
      //   if (json.resultado > 0) {
      //     _this.$store.dispatch('login', true)
      //     _this.$router.push('packages')
      //   } else {
      //     _this.snackbarLogin = true
      //   }
      // })
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../assets/css/login.scss"
</style>